import { dataTablePropsSchema } from '../component-catalog.js';
export const dataTableDefinition = {
    type: 'DataTable',
    category: 'data',
    propsSchema: dataTablePropsSchema,
    isDataBacked: true,
    // `visibleColumns` is an array of column refs; the validator iterates array values.
    columnRefManifest: ['sortColumn', 'visibleColumns'],
    needsMeasuredDims: true,
    defaultHeight: 400,
    description: 'Tabular view of a dataset. Props: sourceDataset (required), mapping? ({ visibleColumns?, sortColumn?, sortDirection? }), editable?.',
};
//# sourceMappingURL=DataTable.js.map